class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener("DOMContentLoaded", function () {
  const lang = document.documentElement.lang || "en";

  const translations = {
    en: [
      "🚚 Free shipping over 60 EUR",
      "💡 Save with pack options",
      "🔐 Secure payment options",
      "💬 Questions? Our team is happy to help"
    ],
    nl: [
      "🚚 Gratis verzending vanaf 60 EUR",
      "💡 Bespaar met bundelopties",
      "🔐 Veilige betaalopties",
      "💬 Vragen? Ons team staat voor je klaar"
    ],
    fr: [
      "🚚 Livraison gratuite dès 60 EUR",
      "💡 Économisez avec les packs",
      "🔐 Options de paiement sécurisées",
      "💬 Des questions ? Notre équipe est là pour vous aider"
    ]
  };

  const messages = translations[lang] || translations.en;

  function injectBenefits() {
    if (document.querySelector(".cart-benefits")) return; // al aanwezig

    const benefitsDiv = document.createElement("div");
    benefitsDiv.classList.add("cart-benefits");
    benefitsDiv.style.background = "#f9f9f9";
    benefitsDiv.style.padding = "1.2rem";
    benefitsDiv.style.borderRadius = "8px";
    benefitsDiv.style.marginBottom = "1.5rem";
    benefitsDiv.style.fontSize = "1.4rem";

    const ul = document.createElement("ul");
    ul.style.listStyle = "none";
    ul.style.paddingLeft = "0";

    messages.forEach(msg => {
      const li = document.createElement("li");
      li.textContent = msg;
      li.style.marginBottom = "0.5rem";
      ul.appendChild(li);
    });

    benefitsDiv.appendChild(ul);

    const targets = [
      document.querySelector(".cart-drawer__footer"),
      document.querySelector("#CartDrawer-Checkout"),
      document.querySelector(".cart__footer"),
      document.querySelector(".cart-items")
    ];

    const target = targets.find(t => t);

    if (target && target.parentNode) {
      target.parentNode.insertBefore(benefitsDiv, target);
    }
  }

  const observer = new MutationObserver(injectBenefits);
  observer.observe(document.body, { childList: true, subtree: true });

  injectBenefits(); // fallback voor directe injectie
});